export default __webpack_public_path__ + "static/media/ad.40a891ec.gif";